import { render, staticRenderFns } from "./JsApiPay.vue?vue&type=template&id=18ce2901&scoped=true&"
import script from "./JsApiPay.vue?vue&type=script&lang=js&"
export * from "./JsApiPay.vue?vue&type=script&lang=js&"
import style0 from "./JsApiPay.vue?vue&type=style&index=0&id=18ce2901&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ce2901",
  null
  
)

export default component.exports